module.exports = __webpack_public_path__ + "img/img-64.0ae80f68.png";